var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#4C1357"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 22.7548C34 21.812 33.9218 21.1239 33.7523 20.4104H22.7347V24.666H29.2018C29.0715 25.7235 28.3674 27.3162 26.8027 28.3864L26.7808 28.5289L30.2644 31.166L30.5057 31.1896C32.7222 29.1892 34 26.2459 34 22.7548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7347 33.9671C25.9031 33.9671 28.5629 32.9478 30.5057 31.1896L26.8027 28.3864C25.8118 29.0617 24.4819 29.5331 22.7347 29.5331C19.6316 29.5331 16.9978 27.5328 16.0589 24.768L15.9213 24.7794L12.2991 27.5188L12.2517 27.6474C14.1814 31.3933 18.1451 33.9671 22.7347 33.9671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0589 24.768C15.8112 24.0545 15.6678 23.2899 15.6678 22.5C15.6678 21.71 15.8112 20.9456 16.0459 20.2321L16.0393 20.0801L12.3717 17.2967L12.2517 17.3525C11.4564 18.9069 11 20.6525 11 22.5C11 24.3475 11.4564 26.093 12.2517 27.6474L16.0589 24.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7347 15.4668C24.9382 15.4668 26.4246 16.3969 27.2721 17.1742L30.5839 14.0143C28.5499 12.1668 25.9031 11.0329 22.7347 11.0329C18.1451 11.0329 14.1814 13.6066 12.2517 17.3525L16.0459 20.232C16.9978 17.4672 19.6316 15.4668 22.7347 15.4668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_95"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.4063305890ea2f9ab245178aed0a4ea7.svg";
export { ForwardRef as ReactComponent };